module.exports = __webpack_public_path__ + "static/img/Dyson-Sharp.a162b69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dyson-Sharp.jpg
// module id = gm14
// module chunks = 0